module.exports = __webpack_public_path__ + "img/slideset-relateditems.6fa0791e.svg";